<template>
  <v-tooltip
    v-if="document && onHelpClick"
    :location="location"
  >
    <template #activator="{ props: tooltipProps }">
      <StandardButton
        @click.stop="onHelpClick(document)"
        v-bind="tooltipProps"
        :aria-label="$bct('Help')"
        :class="iconClass"
        :icon-size="size"
        icon="help_outline"
        role="link"
      />
    </template>
    <span>{{ $bct('View help') }}</span>
  </v-tooltip>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  document: {
    type: Object,
    default: null,
  },
  location: {
    type: String,
    default: 'bottom',
  },
  iconClass: {
    type: String,
    default: 'd-inline ps-1 pt-0 pb-1 cursor-pointer',
  },
  onHelpClick: {
    type: Function,
    default: null,
  },
  size: {
    type: [String, Number],
    default: '18',
  },
});
</script>
